import {Image, Link} from '@shopify/hydrogen';
import Carousel from 'nuka-carousel';

import {NavigationChevronRightIcon} from '~/components';
import {
  AnnouncementItem,
  GetAnnouncementBarByIdResponse,
} from '~/graphql/strapi/homepageDataQuery';

type Props = {
  homepageData: {data: GetAnnouncementBarByIdResponse};
};

const defaultAnnouncements: AnnouncementItem[] = [
  {
    id: '1',
    description: 'Timesavers - One booking, two services',
    link: '/collections/timesavers',
    icon: null,
    iconPosition: null,
  },
  {
    id: '2',
    description: 'Rated 5-stars by thousands like you',
    link: null,
    icon: null,
    iconPosition: null,
  },
  {
    id: '3',
    description: 'Book in as little as 2 hours',
    link: null,
    icon: null,
    iconPosition: null,
  },
  {
    id: '4',
    description: 'Subscribe for better beauty at better prices',
    link: '/subscriptions',
    icon: null,
    iconPosition: null,
  },
];

export function MarketingBar({homepageData}: Props) {
  // prettier-ignore
  const announcements = homepageData.data?.announcementBars[0]?.announcementItem || defaultAnnouncements;

  return (
    <Carousel
      autoplay={true}
      wrapAround={true}
      // withoutControls={true}
      renderCenterLeftControls={({previousDisabled, previousSlide}) => (
        <button
          onClick={previousSlide}
          disabled={previousDisabled}
          className="bg-acai-900 p-2"
        >
          <NavigationChevronRightIcon
            stroke="#F7F4F1"
            width={12}
            height={12}
            className="rotate-180"
          />
        </button>
      )}
      renderCenterRightControls={({nextDisabled, nextSlide}) => (
        <button
          onClick={nextSlide}
          disabled={nextDisabled}
          className="bg-acai-900 p-2"
        >
          <NavigationChevronRightIcon stroke="#F7F4F1" width={12} height={12} />
        </button>
      )}
      renderBottomCenterControls={null}
      className="bg-acai-900 !text-[9px] text-white xs:!text-xs"
    >
      {announcements.map((announcement) => {
        const {description, link, id, icon, iconPosition} = announcement;

        const image = icon?.url && (
          <Image
            src={icon.url}
            width={24}
            height={24}
            alt={'announcement icon'}
            className={`${
              iconPosition === 'left' ? 'mr-1' : 'ml-1'
            } h-[16px] w-full`}
          />
        );

        if (!link) {
          return (
            <div
              key={id}
              className="flex h-[32px] justify-center overflow-hidden p-2"
            >
              <span className="flex whitespace-nowrap">
                {iconPosition === 'left' && image}
                {description}
                {iconPosition === 'right' && image}
              </span>
            </div>
          );
        }

        return (
          <div
            key={id}
            className="flex h-[32px] justify-center overflow-hidden p-2"
          >
            <Link to={link} className="flex whitespace-nowrap">
              {iconPosition === 'left' && image}
              {description}
              {iconPosition === 'right' && image}
            </Link>
          </div>
        );
      })}
    </Carousel>
  );
}
